export interface AiAccessInput {
  orgAvailable: boolean;
  userEnabled: boolean;
}

export function isOnForUser({ orgAvailable, userEnabled }: AiAccessInput): boolean {
  return orgAvailable && userEnabled;
}
